import moment from 'moment';
import { Common, ApiBind } from './common.model';
import { PlacementRelation } from './placement-relation.model';
import { DeliveryControl } from './delivery-control.model';
import { DeliverySetStatus, DeliverySetCondition } from '../constants';
import { DeliverySetDeviceModelGroup } from './delivery-set-device-model-group.model';
import { DeliverySetOsGroup } from './delivery-set-os-group.model';
import { DeliverySetSdkVersionGroup } from './delivery-set-sdk-version-group.model';
import { DeliverySetIpGroup } from './delivery-set-ip-group.model';
import { DeliverySetTester } from './delivery-set-tester.model';
import { DeliverySetTesterCustom } from './delivery-set-tester-custom.model';

export class DeliverySet extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'status' })
  status: DeliverySetStatus;

  @ApiBind({ column: 'delivery_condition' })
  deliveryCondition: DeliverySetCondition;

  @ApiBind({ column: 'schedule_from', model: (value) => moment(value).toDate() })
  scheduleFrom: Date;

  @ApiBind({ column: 'schedule_to', model: (value) => moment(value).toDate() })
  scheduleTo: Date;

  @ApiBind({ column: 'placement_relation_id' })
  placementRelationId: number;

  @ApiBind({ column: 'placement_relation', model: (value) => new PlacementRelation(value) })
  placementRelation: PlacementRelation;

  @ApiBind({ column: 'floor_price' })
  floorPrice: number;

  @ApiBind({ column: 'floor_price_optimize_enabled' })
  floorPriceOptimizeEnabled: number;

  @ApiBind({ column: 'enable_automatic_ratio' })
  enableAutomaticRatio: number;

  @ApiBind({ column: 'lp_open_method' })
  lpOpenMethod: number;

  @ApiBind({ column: 'delivery_control_type' })
  deliveryControlType: number;

  @ApiBind({ column: 'delivery_controls', model: (values) => values.map(value => new DeliveryControl(value)) })
  deliveryControls: DeliveryControl[];

  @ApiBind({ column: 'priority' })
  priority: number;

  @ApiBind({ column: 'ratio' })
  ratio: number;

  @ApiBind({ column: 'device_model_groups', model: (values) => values.map(value => new DeliverySetDeviceModelGroup(value)) })
  deliverySetDeviceModelGroups: DeliverySetDeviceModelGroup[];

  @ApiBind({ column: 'os_groups', model: (values) => values.map(value => new DeliverySetOsGroup(value)) })
  deliverySetOsGroups: DeliverySetOsGroup[];

  @ApiBind({ column: 'sdk_version_groups', model: (values) => values.map(value => new DeliverySetSdkVersionGroup(value)) })
  deliverySetSdkVersionGroups: DeliverySetSdkVersionGroup[];

  @ApiBind({ column: 'ip_groups', model: (values) => values.map(value => new DeliverySetIpGroup(value)) })
  deliverySetIpGroups: DeliverySetIpGroup[];

  @ApiBind({ column: 'testers', model: (values) => values.map(value => new DeliverySetTester(value)) })
  deliverySetTesters: DeliverySetTester[];

  @ApiBind({ column: 'tester_customs', model: (values) => values.map(value => new DeliverySetTesterCustom(value)) })
  deliverySetTesterCustoms: DeliverySetTesterCustom[];

  @ApiBind({ column: 'is_emergency_stop' })
  isEmergencyStop: boolean;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  @ApiBind({ column: 'updated_by' })
  updatedBy: string;

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }

  public toUpdateScheduleItemJSON() {
    return {
      id: this.convertJSONObject(this.id), schedule_from: this.convertJSONObject(this.scheduleFrom),
      schedule_to: this.convertJSONObject(this.scheduleTo), updated_at: this.convertJSONObject(this.updatedAt)
    };
  }

}
